import { updateAnalyticsByTestId } from "../api/analytics";
import { ANALYTICS_ENDPOINT } from "../api/endpoints";
import { AnalyticsData, AnalyticsDataFromAPI } from "../api/types";
import useSWRImmutable from "swr/immutable";
import useTestId from "./useTestId";

const useAnalytics = () => {
    const testId = useTestId();
    const { data, mutate } = useSWRImmutable<AnalyticsDataFromAPI>(
        `${ANALYTICS_ENDPOINT}?test_id=${testId}`
    );

    const updateAnalytics = async (data: Partial<AnalyticsData>) => {
        if (!testId) {
            console.warn("No testId available for updating analytics");
            return;
        }
        const resData = await updateAnalyticsByTestId(testId, data);
        mutate(resData, false);
        return resData;
    };

    const analytics: AnalyticsData | undefined = data
        ? {
              scale: data.scale ?? 1,
              scroll_position: data.scroll_position ?? 0,
              ...data,
          }
        : undefined;

    return {
        analytics,
        mutateAnalytics: mutate,
        updateAnalytics,
    };
};

export default useAnalytics;
